import Lookup from './lookup.js';

export default class HousingType extends Lookup
{
    
}
